export const MENU_TYPE = {
  LK_CLIENT: 'lk_client',
  LK_BROKER: 'lk_broker',
};
